import { RotateCcw, Sparkles } from "lucide-react";
import { TONE_TWEAKS } from "@/lib/config";
import { AnalysisCard } from "./AnalysisCard";
import { ReplyCard } from "./ReplyCard";
import { QuotaBlock } from "@/components/UsagePill";

const Skeleton = () => (
  <div className="space-y-3" data-testid="replies-loading">
    <div className="text-sm text-muted-foreground flex items-center gap-2"><Sparkles className="h-4 w-4 text-accent animate-pulse" />Reading the vibe and writing three options…</div>
    {[0, 1, 2].map((i) => <div key={i} className="h-28 rounded-3xl shimmer" />)}
  </div>
);

export const Results = ({ state, error, quota, result, onRetry, onTweak, onRegenerate, onEdit, regenIdx, voice, voiceAvailable }) => {
  if (state === "loading") return <Skeleton />;
  if (state === "error" && quota) return <QuotaBlock message={error} />;
  if (state === "error") {
    return (
      <div className="panel p-5 border-rose-500/40" data-testid="generate-error">
        <p className="text-sm mb-3">{error}</p>
        <button data-testid="generate-retry-button" onClick={onRetry} className="h-10 px-5 rounded-full brand-gradient text-white text-sm font-semibold inline-flex items-center gap-2"><RotateCcw className="h-4 w-4" />Retry</button>
      </div>
    );
  }
  if (!result) return null;
  return (
    <div className="space-y-4" data-testid="results-section">
      <AnalysisCard analysis={result.analysis} latency={result.latency_ms} />
      <div className="flex flex-wrap gap-2" data-testid="tone-tweaks">
        <span className="text-xs text-muted-foreground self-center mr-1">Different tone:</span>
        {TONE_TWEAKS.map((t) => (
          <button key={t.id} data-testid={`tone-tweak-${t.id}`} onClick={() => onTweak(t.value)} className="h-8 px-3 rounded-full border border-border text-xs font-medium hover:border-primary/50 hover:bg-secondary transition-colors">{t.label}</button>
        ))}
      </div>
      {result.replies.map((r, i) => (
        <ReplyCard key={i} reply={r} index={i} onRegenerate={onRegenerate} onEdit={onEdit} regenerating={regenIdx === i} voice={voice} voiceAvailable={voiceAvailable} />
      ))}
      <p className="text-[11px] text-muted-foreground">AI suggestions — review before sending. Nothing is sent automatically.</p>
    </div>
  );
};
